import dayjs from 'dayjs'
import { FC, useMemo } from 'react'

import { FileApiType } from '@/api/shared/types'
import { cn } from '@/app/utils'
import { FileUploadedCard } from '@/components/shared/file-viewer'
import { isFileImageByPath } from '@/utils/file'
import { makePhonesAndLinksClickable } from '@/utils/makePhonesAndLinksClickable'

type Props = {
  date: string | Date
  onLinkClick: (url: string) => void
  message?: string
  file?: FileApiType
  withDate?: boolean
}

const CommentsUserMessage: FC<Props> = ({
  message,
  date,
  file,
  onLinkClick,
  withDate = true
}) => {
  const isImage = useMemo(
    () => isFileImageByPath(file?.name || ''),
    [file?.name]
  )

  return (
    <>
      {message || file ? (
        <div
          data-testid="chat-user-message-id"
          className={cn(
            'flex flex-col items-end',
            withDate ? 'mb-4 last:mb-0' : 'last:mb-0'
          )}
        >
          {message && (
            <div className="mb-2 max-w-[556px] rounded-l-12 rounded-tr-12 bg-bronze-50 p-12 lg:max-w-[476px] sm:max-w-[302px]">
              <p
                data-testid="chat-user-message-text-id"
                className="whitespace-pre-line break-words font-pro text-white text-16"
              >
                {makePhonesAndLinksClickable(message, onLinkClick, 'underline')}
              </p>
            </div>
          )}
          {file && (
            <div
              data-testid="chat-user-message-file-id"
              className={cn(
                'mb-2 max-w-[556px] bg-bronze-50 p-12 lg:max-w-[476px] sm:max-w-[302px]',
                isImage ? 'rounded-12' : 'rounded-l-12 rounded-tr-12'
              )}
            >
              <FileUploadedCard
                file={file}
                inline={true}
                imgSizeClassName="h-[180px] w-[180px]"
                contentClassName="text-white"
              />
            </div>
          )}
          {withDate && (
            <p
              data-testid="chat-user-message-time-id"
              className="text-medium font-pro text-grey-50 text-10"
            >
              {dayjs(date).format('HH:mm')}
            </p>
          )}
        </div>
      ) : (
        <></>
      )}
    </>
  )
}

export { CommentsUserMessage }
